import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["notification"];

  disconnect() {
    $(this.notificationTarget).remove();
  }

  connect() {
    if (!document.documentElement.hasAttribute("data-turbolinks-preview")) {
      this.showFlashNotifications();
    }
  }

  showFlashNotifications() {
    const element = this.notificationTarget;

    $.notify({
      message: element.textContent,
    }, {
      type: element.dataset.notificationClass
    });
  }
}
